(function () {
    'use strict';
    angular.module('wamasysApp').controller('WindowsPreparationController', WindowsPreparationController);
    WindowsPreparationController.$inject = ['$http', '$window', '$scope'];
    function WindowsPreparationController($http, $window, $scope) {
        var vm = this, endpoint = 'api/account/windows-preparation', active = true;
        vm.status = {}; vm.load = load; vm.download = download;
        function load() {
            vm.loading = true; vm.error = false; vm.status = {};
            return $http.get(endpoint).then(function (response) { if (active) { vm.status = response.data; } })
                .catch(function () { if (active) { vm.error = true; } })
                .finally(function () { if (active) { vm.loading = false; } });
        }
        function download() {
            if (!vm.status.allowed || vm.loading || vm.downloading) { return; }
            vm.error = false; vm.downloaded = false; vm.downloading = true;
            var baseUrl = ($window.location.origin + $window.location.pathname).replace(/\/index\.html$/, '').replace(/\/$/, '');
            // Le serveur vérifie à nouveau l’autorisation et détermine le rattachement du poste.
            return $http.post(endpoint, {apiBaseUrl: baseUrl}, {responseType: 'arraybuffer'}).then(function (response) {
                if (!active) { return; }
                var url = $window.URL.createObjectURL(new $window.Blob([response.data], {type: 'application/zip'})), link = $window.document.createElement('a');
                link.href = url; link.download = 'windows-workstation-preparation.zip';
                $window.document.body.appendChild(link); link.click(); $window.document.body.removeChild(link);
                $window.setTimeout(function () { $window.URL.revokeObjectURL(url); }, 1000);
                vm.downloaded = true;
            }).catch(function (error) {
                if (active) { vm.error = true; if (error.status === 403) { vm.status.allowed = false; vm.status.reason = 'DISABLED'; } }
            }).finally(function () { if (active) { vm.downloading = false; } });
        }
        $scope.$on('$destroy', function () { active = false; });
        load();
    }
})();
